import { Dialog, DialogContent, DialogActions } from '@mui/material';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import * as React from 'react';
import moment from 'moment';
import DialogTitle from '@mui/material/DialogTitle';
import { useMutation } from '@apollo/client';
import AddIcon from '@mui/icons-material/Add';
import Alert from '@mui/material/Alert';
import { WarningAmber } from '@mui/icons-material';

import { ADD_TIME_BLOCK } from '../../apis/user';
import Button from '../atoms/button';

const { RangePicker } = DatePicker;

const propTypes = {
  userId: PropTypes.number,
  userName: PropTypes.string,
  onSave: PropTypes.func,
  canAddTimeBlock: PropTypes.bool,
  setIsLoading: PropTypes.func,
};

const defaultProps = {
  userId: 0,
  userName: '',
  onSave: () => {},
  canAddTimeBlock: false,
};

const DateRangePicker = ({ userId, userName, onSave, canAddTimeBlock, setIsLoading }) => {
  const [open, setOpen] = React.useState(false);
  const [dates, setDates] = React.useState([]);
  const [alert, setAlert] = React.useState('');

  const [addTimeBlock] = useMutation(ADD_TIME_BLOCK);

  const dialogText = `Block out time on ${userName}'s calendar when they will be unavailable. ${userName} will not
                  get scheduled during this time.`;

  const handleClose = () => {
    setOpen(false);
    setDates([]);
    setAlert('');
  };

  const saveTimeBlock = async () => {
    if (dates[0] && dates[1] && userId) {
      setIsLoading(true);
      setOpen(false);
      const variables = {
        input: {
          user_id: userId,
          start_date: dates[0],
          end_date: dates[1],
        },
      };
      const timeBlockData = await addTimeBlock({ variables });
      if (timeBlockData?.data?.createTimeBlock?.id === null) {
        setAlert('A time block already exists within this date range.');
      } else {
        setAlert('');
        await onSave();
      }
      setDates([]);
      setIsLoading(false);
    } else {
      setOpen(true);
    }
  };

  return (
    <div>
      <div>
        <div className="time-add-block">
          <span className="user-detail-title">Time Blocks</span>
          {canAddTimeBlock && (
            <Button primary text startIcon={<AddIcon fontSize="small" />} onClick={() => setOpen(true)}>
              Add Time Block
            </Button>
          )}
        </div>
        <Dialog
          className="custom-modal-dialog add-time-block-modal-dialog"
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Add Time Block</DialogTitle>
          <DialogContent className="dialog-content">
            <div className="time-block-content">
              <p>{dialogText}</p>

              <RangePicker
                disabledDate={(current) => current && current < moment().subtract(1, 'days')}
                onChange={(values) => {
                  if (values) {
                    setDates(values.map((item) => moment(new Date(item)).format('YYYY-MM-DD')));
                  }
                  setAlert('');
                }}
              />

              {alert && (
                <div className="alert-msg">
                  <Alert icon={<WarningAmber />}>{alert}</Alert>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions className="dialog-actions">
            <Button primary outlined onClick={handleClose}>Cancel</Button>
            <Button primary onClick={saveTimeBlock}>Save</Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

DateRangePicker.propTypes = propTypes;
DateRangePicker.defaultProps = defaultProps;
export default DateRangePicker;
